<template>
    <div>
        <manage-header></manage-header>
        <div class="head xy-center">
            <img :src="require('@/assets/img/defaulteActor.png')" alt="" />
            <div style="margin-left: 10px">
                <div class="font-size18 c-fff">
                    Hi,{{ $store.state.userInfo.UserName }}
                </div>
                <div class="organ-name">
                    {{ $store.state.userInfo.OrganName }}
                </div>
            </div>
        </div>
        <div class="body xy-start" style="width: 75%">
            <div class="nav-bar">
                <el-menu router unique-opened ref="el-menu">
                    <template v-for="item in routes">
                        <el-submenu
                            v-if="item.children && item.children.length"
                            :key="item.path"
                            :index="'/manage/' + item.path"
                        >
                            <div slot="title">{{ item.meta.title }}</div>
                            <el-menu-item
                                v-for="sub in item.children"
                                :key="sub.path"
                                :index="sub.path"
                                :route="sub">
                                <div slot="title">
                                    {{ sub.meta.title }}
                                </div>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item
                            v-else
                            :key="item.path"
                            :route="item"
                            :index="item.path"
                        >
                            <div slot="title">
                                {{ item.meta.title }}
                            </div>
                        </el-menu-item>
                    </template>
                </el-menu>
            </div>

            <keep-alive v-if="keepAlive">
                <router-view class="nav-body"></router-view>
            </keep-alive>
            <router-view v-if="!keepAlive" class="nav-body"></router-view>
        </div>
    </div>
</template>

<script>
import ManageHeader from "@/components/manager/ManageHeader";
import { isEmpty } from "@/utils";

export default {
    name: "index",
    components: { ManageHeader },
    computed: {
        routes() {
            if (isEmpty(this.$router.adminRoutes)) {
                return []
            }
            /**
             * 筛除 meta.hidden == true 的路由
             * @param list 路由数组
             * @return {[]} 新路由数组
             */
            function filterHide(list) {
                let result = []
                list.forEach(el => {
                    if (!el.meta.hidden) {
                        if (el.children && el.children.length > 0) {
                            let _el = Object.assign({}, el)
                            _el.children = filterHide(_el.children)
                            result.push(_el)
                        } else {
                            result.push(el)
                        }
                    }
                })
                return result;
            }
            console.log(filterHide(this.$router.adminRoutes[0].children), 'filter')
            return filterHide(this.$router.adminRoutes[0].children);
        },
        keepAlive () {
            return this.$route.meta?.alive
        }
    },
    watch: {
        '$route.path' (val) {
            this.$nextTick().then(() => {
                const elMenu = this.$refs["el-menu"]
                if (elMenu) {
                    const meta = this.$route.meta || Object.create(null)
                    // elMenu.open(meta.subMenuItem || val.slice(0, val.lastIndexOf('/')))
                    elMenu.updateActiveIndex(meta.menuItemActive || this.$route.name)
                }
            })
        }
    },
    methods: {
    }
};
</script>

<style scoped lang="less">
@import "../../styles/manage";
.head {
    box-sizing: border-box;
    padding-bottom: 60px;
    margin-top: 70px;
    height: 200px;
    background: url("../../assets/img/admin/admin-head.png");
    img {
        width: 60px;
        height: 60px;
    }
    .organ-name {
        font-size: 14px;
        color: #ffffff;
        margin-top: 10px;
    }
}
.body {
    margin: -60px auto 60px auto;
    .nav-bar {
        width: 220px;
        border-radius: 16px;
        position: sticky;
        top: 100px;
        .el-menu-item.is-active {
            background-color: #e8f1ff;
        }
        ::v-deep .el-menu[role="menubar"] {
            border-radius: 16px;
            overflow: auto;
            border-right: unset;
            width: 220px;
            min-height: calc(100vh - 160px);
        }
    }
    .nav-body {
        flex-grow: 1;
        margin-left: 30px;
    }
}
</style>
